import type { ProjectListItem } from '@/types/project';
import { ProjectLinkedDailyReportsSection } from '@/pages/admin/projects/ProjectLinkedDailyReportsSection';

interface ProjectReportAdminSectionProps {
  project: ProjectListItem;
}

/** @deprecated 使用 ProjectLinkedDailyReportsSection */
export function ProjectReportAdminSection({ project }: ProjectReportAdminSectionProps) {
  return (
    <ProjectLinkedDailyReportsSection
      projectId={project.id}
      projectName={project.name}
      showHint
    />
  );
}
